module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-0 mt-2"
  }, [_vm._v(_vm._s(_vm.titleTransfer) + ": " + _vm._s(_vm.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "text-xs-right": "",
      "mb-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.assignToMinibar
    }
  }, [_vm._v("\n\t\t\t\tAsignar al " + _vm._s(_vm.assignText) + "\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false,
      "key-value": "warehouseProductId"
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('router-link', {
          staticClass: "to-kardex",
          attrs: {
            "to": {
              name: 'kardex',
              params: {
                productId: props.row.id,
                productName: props.row.name,
                warehouseId: props.row.warehouseId
              }
            }
          }
        }, [_vm._v("\n\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouseName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.stock))]), _vm._v(" "), _c('td', {
          staticClass: "pr-2"
        }, [_c('v-text-field', {
          staticClass: "time-standard-input",
          attrs: {
            "type": "number",
            "min": "1",
            "step": "1",
            "suffix": props.row.unitCode
          },
          on: {
            "keyup": function($event) {
              _vm.toInt(props.row.quantity)
            }
          },
          model: {
            value: (props.row.quantity),
            callback: function($$v) {
              props.row.quantity = $$v
            },
            expression: "props.row.quantity"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "pr-2"
        }, [_c('v-text-field', {
          staticClass: "time-standard-input stock",
          attrs: {
            "type": "number",
            "min": "1",
            "step": "1"
          },
          on: {
            "keyup": function($event) {
              _vm.absolute(props.row.minStock)
            }
          },
          model: {
            value: (props.row.minStock),
            callback: function($$v) {
              props.row.minStock = _vm._n($$v)
            },
            expression: "props.row.minStock"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56bbf450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/minibar/Products.vue
// module id = 1642
// module chunks = 15